import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostOdontoProviders,
	PostOdontoProvidersModel,
	PostOdontoProvidersParams,
} from 'domain/usecases/private/booking-flow/odonto/post-odonto-providers';

export class RemotePostOdontoProviders implements PostOdontoProviders {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostOdontoProvidersModel>,
	) {}

	async post({signal, ...params}: PostOdontoProvidersParams): Promise<PostOdontoProvidersModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
